import { render, staticRenderFns } from "./HelpCenterWhatsNewState.vue?vue&type=template&id=408975cf&scoped=true&"
import script from "./HelpCenterWhatsNewState.vue?vue&type=script&lang=js&"
export * from "./HelpCenterWhatsNewState.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenterWhatsNewState.vue?vue&type=style&index=0&id=408975cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408975cf",
  null
  
)

export default component.exports